import React from 'react';
import { Market, UserProfile } from '../types.ts';
import { LMSRBuyPanel } from './LMSRBuyPanel.tsx';
import { LMSRSellPanel } from './LMSRSellPanel.tsx';
import { PoolBuyPanel } from './PoolBuyPanel.tsx';

interface PlaceBetFormProps {
  market: Market;
  userProfile: UserProfile | null;
  selectedOptionId: number | null;
  onCancel: () => void;
  onBetSuccess?: () => void | Promise<void>;
  /** Share-priced markets only: which side of the trade widget to show. */
  lmsrTradeMode?: 'buy' | 'sell';
}

/**
 * Routes to the correct buy panel based on the market's engine_type.
 * - engine_type === 'lmsr' → fixed-price buy panel (live shares / price)
 * - engine_type === 'pool' (default) → PoolBuyPanel (shared pool, odds-based)
 */
export function PlaceBetForm({
  market,
  userProfile,
  selectedOptionId,
  onCancel,
  onBetSuccess,
  lmsrTradeMode = 'buy',
}: PlaceBetFormProps) {
  if (market.engine_type === 'lmsr') {
    if (lmsrTradeMode === 'sell') {
      return (
        <LMSRSellPanel
          market={market}
          userProfile={userProfile}
          selectedOptionId={selectedOptionId}
          onCancel={onCancel}
          onBetSuccess={onBetSuccess}
        />
      );
    }
    return (
      <LMSRBuyPanel
        market={market}
        userProfile={userProfile}
        selectedOptionId={selectedOptionId}
        onCancel={onCancel}
        onBetSuccess={onBetSuccess}
      />
    );
  }

  return (
    <PoolBuyPanel
      market={market}
      userProfile={userProfile}
      selectedOptionId={selectedOptionId}
      onCancel={onCancel}
      onBetSuccess={onBetSuccess}
    />
  );
}
